<div class="form-group">
  @if (showLabel && (question?.question_copy || question?.email_version)) {
    <label [innerHtml]="question?.question_copy || question?.email_version" class="form-group__label"></label>
  }

  <input [name]="uniqueControlName"
    (keyup)="upperCase()"
    [id]='uniqueId'
    [attr.placeholder]="question?.question_prompt"
    type="text"
    mask="0000"
    [(ngModel)]="value" (ngModelChange)="saveValue()" [disabled]="readOnly" class="form-control"
    >
  </div>